// src\dev\common\ErrorBoundary.js
import React from 'react';
import ErrorPage from './ErrorPage'

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { errorMessage: '', errorDetails: '' };
  }

  static getDerivedStateFromError(errorMessage) {
    return { errorMessage }
  }

  componentDidCatch(errorMessage, errorDetails) {
    this.setState({errorMessage: errorMessage, errorDetails: errorDetails.componentStack})
  }

  render() {
    if (this.state.errorMessage) {
      return <ErrorPage errorMessage={this.state.errorMessage.toString()} errorDetails={this.state.errorDetails} />
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
